// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"ef5f54b0","357":"4423f6ad","647":"e4671864","707":"907acf5b"}[chunkId] + ".chunk.css";
};